import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'fk-modal',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  template: `
    <div *ngIf="isOpen" class="fixed inset-0 z-[200] flex items-center justify-center p-4 overflow-hidden">
      <!-- Backdrop -->
      <div class="fixed inset-0 bg-slate-900/60 backdrop-blur-sm animate-in fade-in duration-300"
        (click)="onBackdropClick()">
      </div>
      
      <!-- Modal Content -->
      <div [class]="modalClass"
        class="relative z-10 bg-white rounded-2xl shadow-2xl animate-in zoom-in slide-in-from-bottom-4 duration-300 overflow-y-auto"
        [style.maxWidth]="maxWidth || null">
        <ng-content></ng-content>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalComponent {
  @Input() isOpen = false;
  @Input() size: 'sm' | 'md' | 'lg' | 'xl' | 'full' | 'auto' = 'auto';
  @Input() maxWidth = '';
  @Input() variant: 'default' | 'media' = 'default';
  @Input() closeOnOutsideClick = true;
  @Output() close = new EventEmitter<void>();

  get modalClass(): string {
    switch (this.size) {
      case 'sm': return 'w-full max-w-sm max-h-[90vh]';
      case 'md': return 'w-full max-w-md max-h-[90vh]';
      case 'lg': return 'w-full max-w-lg max-h-[90vh]';
      case 'xl': return 'w-[90vw] max-w-[90vw] h-[95vh] max-h-[95vh]';
      case 'full': return 'w-screen h-screen max-w-none max-h-none rounded-none';
      case 'auto':
      default: return 'max-h-[90vh]';
    }
  }

  onClose() {
    this.close.emit();
  }

  onBackdropClick() {
    // Outside clicks are ignored by default so forms do not close accidentally.
    if (this.closeOnOutsideClick) {
      this.onClose();
    }
  }
}
